import { REQUEST_WIZARD_RATE, RECEIVE_WIZARD_RATE } from '../actions';

export function rate(state = { rate: null, wizardIsFetchingRate: false }, action) {
  switch (action.type) {
    case REQUEST_WIZARD_RATE:
      return {
        ...state,
        wizardIsFetchingRate: true,
      };

    case RECEIVE_WIZARD_RATE:
      return {
        ...state,
        rate: action.rate,
        wizardIsFetchingRate: false,
      };
  }

  return state;
}
